import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { FormioUtils } from 'angular-formio';
import { Settings } from '../../shared/models/settings/settings.model';
import { getAllComponents } from '../utilities/form';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe-decorator';

@Injectable({
  providedIn: 'root',
})
export class FormObserverService {
  @AutoUnsubscribe()
  private formData = new BehaviorSubject<any>({});
  castFormData = this.formData.asObservable();

  @AutoUnsubscribe()
  private isRecurringForm = new BehaviorSubject<boolean>(false);
  castIsRecurringForm = this.isRecurringForm.asObservable();

  @AutoUnsubscribe()
  private hasCommercialItem = new BehaviorSubject<boolean>(false);
  castHasCommercialItem = this.hasCommercialItem.asObservable();

  @AutoUnsubscribe()
  private value = new BehaviorSubject<any>(false);
  castValue = this.value.asObservable();

  @AutoUnsubscribe()
  private recaptchaResponse = new BehaviorSubject<any>({});
  castRecaptchaResponse = this.recaptchaResponse.asObservable();

  //for multi product field dropdown
  @AutoUnsubscribe()
  private productlists = new BehaviorSubject<any>([]);
  castproductlists = this.productlists.asObservable();

  @AutoUnsubscribe()
  private selectedproductlists = new BehaviorSubject<any>({});
  castselectedproductlists = this.selectedproductlists.asObservable();

  @AutoUnsubscribe()
  private totalselectedproduct = new BehaviorSubject<number>(0);
  casttotalselectedproduct = this.totalselectedproduct.asObservable();

  @AutoUnsubscribe()
  private productFieldLabel = new BehaviorSubject<any>({});
  castproductFieldLabel = this.productFieldLabel.asObservable();

  //for terms and condition
  @AutoUnsubscribe()
  private termsconditioncontent = new BehaviorSubject<string>('');
  cast_termsconditioncontent = this.termsconditioncontent.asObservable();

  //for taxjar field component
  @AutoUnsubscribe()
  private taxjarfieldvalues = new BehaviorSubject<any>({});
  casttaxjarfieldvalues = this.taxjarfieldvalues.asObservable();

  @AutoUnsubscribe()
  private taxjarAmountToken = new BehaviorSubject<number>(0);
  casttaxamount = this.taxjarAmountToken.asObservable();

  @AutoUnsubscribe()
  private businessData = new BehaviorSubject<any>({});
  castBusinessData = this.businessData.asObservable();

  //for Form validation needed for Credit Card Form
  @AutoUnsubscribe()
  private formValidation = new BehaviorSubject<boolean>(false);
  castFormvalidation = this.formValidation.asObservable();

  @AutoUnsubscribe()
  private castValue$: Subscription;
  @AutoUnsubscribe()
  private castFormData$: Subscription;

  constructor() {}

  setFormData(formData: any) {
    this.formData.next(formData);
  }

  setIsRecurringForm(configData: any) {
    this.isRecurringForm.next(configData);
  }

  setHasCommercialItem(configData: any) {
    this.hasCommercialItem.next(configData);
  }

  setRecaptchaResponse(response: any) {
    this.recaptchaResponse.next(response);
  }

  //for multi product field dropdown
  updateProductLists(productlists) {
    this.productlists.next(productlists);
  }

  updateSelectedProductLists(selectedproductlists) {
    this.selectedproductlists.next(selectedproductlists);
  }

  updateTotalSelectedProduct(totalselectedproduct) {
    this.totalselectedproduct.next(totalselectedproduct);
  }

  updateProductFieldLabel(productFieldLabel) {
    this.productFieldLabel.next(productFieldLabel);
  }

  // for terms and condition content
  updateTermsCondition(termsconditioncontent) {
    this.termsconditioncontent.next(termsconditioncontent);
  }

  // for form validation
  updateFormValidation(isFormValid: boolean) {
    this.formValidation.next(isFormValid);
  }

  // for taxjar field payload
  updateTaxjarFieldValues(taxjarfieldvalues) {
    this.taxjarfieldvalues.next(taxjarfieldvalues);
  }

  updateTaxjarAmountData(tokenData) {
    this.taxjarAmountToken.next(tokenData);
  }

  // business data cache
  updateBusinessData(businessData: Settings) {
    this.businessData.next(businessData);
  }

  /**
   * Get the component property value
   *
   * Key can be a single level or  nested.
   * For Nested: customOptions.locationId
   *
   * @param componentKey
   * @param key
   * @param name
   */
  getProperty(componentKey: string, key: string, name: any = false) {
    this.castFormData$ = this.castFormData.subscribe((formData) => {
      if (formData) {
        formData = getAllComponents(formData);
        // if (formData.filter) {
        if (typeof formData.filter == 'function') {
          const formComponent = formData.filter((component) => {
            if (name) {
              return component.type === componentKey && component.key === name;
            }
            return component.type === componentKey;
          })[0];
          if (formComponent) {
            const property = key.split('.');
            if (property.length > 1) {
              try {
                const reducer = (accumulator, currentValue) =>
                  formComponent[accumulator][currentValue];
                this.value.next(property.reduce(reducer));
                return;
              } catch (e) {
                if (e) {
                }
              }
            }
            this.value.next(formComponent[key]);
          } else {
            this.value.next(false);
          }
        }
      }
    });
  }
  castProperty(componentKey: string, key: string, name: any = false) {
    let propertyValue;
    this.getProperty(componentKey, key, name);
    this.castValue$ = this.castValue.subscribe((value) => {
      propertyValue = value;
    });
    if (propertyValue) {
      return propertyValue || propertyValue.toString();
    } else {
      return false;
    }
  }

  searchComponent(type: string, name: string) {
    let result = [];
    this.castFormData$ = this.castFormData.subscribe((formData: any) => {
      result = FormioUtils.searchComponents(formData, {
        type: type,
        key: name,
      });
    });

    return (result && result[0]) || false;
  }
}
